import React__default from 'react';

//@index('./*', f => `export * from '${f.path}';`)
//@endindex
var isNil = function (input) { return input == null; };
var exists = function (input) { return input !== null && input !== undefined; };
var isNumber$1 = function (input) { return typeof input === 'number' && !isNaN(input); };
var isEmpty = function (input) {
    var _a;
    if (isNil(input)) {
        return true;
    }
    if (typeof input === 'number')
        return isNaN(input);
    if (typeof input === 'object')
        return Object.keys(input).length === 0;
    if (typeof input === 'string')
        return ((_a = input.trim()) === null || _a === void 0 ? void 0 : _a.length) === 0;
    return isNil(input);
};
var isNotEmpty = function (input) {
    return !isEmpty(input);
};

var Enabled = function (_a) {
    var value = _a.value, children = _a.children;
    if (!value)
        return null;
    return React__default.createElement(React__default.Fragment, null, children);
};
var Exists = function (_a) {
    var value = _a.value, children = _a.children;
    if (isNil(value))
        return null;
    return React__default.createElement(React__default.Fragment, null, children);
};

const ianaRegex =
  /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
combineRegexes(isoTimeRegex);

combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
combineRegexes(sqlTimeRegex);
var toNaturalLanguage = function (date, options) {
    return new Date(date).toLocaleDateString('en-US', options);
};
var toNaturalLanguageTimeString = function (date, options) {
    return new Date(date).toLocaleTimeString('en-US', options);
};

var wrap = function (inf) { return inf; };

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var _this = undefined;
var debounce = function (func, timeout) {
    if (timeout === void 0) { timeout = 500; }
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, args);
        }, timeout);
    };
};

export { Enabled, Exists, debounce, exists, isEmpty, isNil, isNotEmpty, isNumber$1 as isNumber, toNaturalLanguage, toNaturalLanguageTimeString, wrap };
